import { Title } from "@mantine/core";
import { L2KH5Props } from "./types";
import { H5_STYLE, COLORS } from "./constants";

/**
 * L2KH5 - Fifth level heading component
 * Renders as <h5> by default, uses Big Shoulders Display font
 * Responsive sizing: 18px → 22px across 320px → 1920px viewports
 */
export function L2KH5({
  children,
  variant = "primary",
  component = "h5",
  style,
  ...props
}: L2KH5Props) {
  return (
    <Title
      order={5}
      component={component}
      style={{
        fontSize: H5_STYLE.fontSize,
        lineHeight: H5_STYLE.lineHeight,
        letterSpacing: H5_STYLE.letterSpacing,
        fontWeight: H5_STYLE.fontWeight,
        fontFamily: H5_STYLE.fontFamily,
        margin: 0,
        color: COLORS[variant],
        ...style,
      }}
      {...props}
    >
      {children}
    </Title>
  );
}
